import type { CategoryTreeNode } from '@tcr-erp/shared';

/** Node cho antd TreeSelect — `title` là tên, `children` theo cấp. */
export interface CategoryTreeSelectNode {
  value: string;
  title: string;
  children?: CategoryTreeSelectNode[];
}

/** Option phẳng cho antd Select — `label` là đường dẫn "Cha / Con" để phân biệt mục trùng tên. */
export interface CategoryOption {
  value: string;
  label: string;
  code: string;
}

export function toCategoryTreeSelectData(nodes: CategoryTreeNode[]): CategoryTreeSelectNode[] {
  return nodes.map((n) => ({
    value: n._id,
    title: n.name,
    children: n.children?.length ? toCategoryTreeSelectData(n.children) : undefined,
  }));
}

/** Duyệt cây theo thứ tự hiển thị (cha trước, con sau) → option phẳng mang đường dẫn đầy đủ. */
export function flattenCategoryTree(nodes: CategoryTreeNode[]): CategoryOption[] {
  const out: CategoryOption[] = [];
  const walk = (list: CategoryTreeNode[], prefix: string) => {
    for (const n of list) {
      const label = prefix ? `${prefix} / ${n.name}` : n.name;
      out.push({ value: n._id, label, code: n.code });
      if (n.children?.length) walk(n.children, label);
    }
  };
  walk(nodes, '');
  return out;
}

export function buildCategoryNameMap(nodes: CategoryTreeNode[]): Map<string, string> {
  const map = new Map<string, string>();
  const walk = (list: CategoryTreeNode[]) => {
    for (const n of list) {
      map.set(n._id, n.name);
      if (n.children?.length) walk(n.children);
    }
  };
  walk(nodes);
  return map;
}
